import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";

const reducer = {
  auth: authReducer,
};

const store = configureStore({
  reducer,
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export default store;
